// Vinit R : 27-09-2023 :  Breeze - Mutual Funds - Start

import { cancelMutualFundOrderAPI, getMutualFundSIPOrdersAPI, getMutualFundsHoldingAPI, getNfoWatchList, getUserAllmutualFundOrders, placeUsermutualFundOrder, placeUsermutualFundSIPOrder, placeUsermutualFundSWPOrder, placeUsermutualFundSwitchOrder } from "../../apis";

const _getMutualFundOrder = async () => {
    try {
        // TODO: This static payload to be removed during API binding
        const data = {
            OBType: "C",
            productCode: 11,
            exchangeCode: 0,
            amcCode: 0,
            transactionType: "A",
            orderStatus: 0,
            subOrderStatus: -1,
            pageNo: 1,
            noOfRecordPerPage: 20,
            fromDate: "23-12-2022",
            toDate: "22-3-2023"
        };
        const objResp = await getUserAllmutualFundOrders(data);
        return Promise.resolve(objResp);
    } catch (error) {
        console.log(error);
        return Promise.reject(error.message);
    }
};

const _getMutualFundSIPOrder = async () => {
    try {
        // TODO: This static payload to be removed during API binding
        const data = {
            productCode: 11,
            exchangeCode: 0,
            amcCode: 0,
            transactionType: "A",
            subTransactionType: 0,
            orderStatus: 0,
            subOrderStatus: -1,
            orderBookType: "C",
            pageNo: 1,
            noOfRecordPerPage: 20
        };
        const objResp = await getMutualFundSIPOrdersAPI(data);
        return Promise.resolve(objResp);
    } catch (error) {
        console.log(error);
        return Promise.reject(error.message);
    }
};

const _createMutualFundOrder = async () => {
    try {
        // TODO: This static payload to be removed during API binding
        const data = {
            OrderType: "P",
            OrderSubType: "F",
            TransactionType: "NEW",
            ExchangeCode: 3,
            AMCCode: "FTI",
            SchemeCode: "6828",
            SchemeType: "BALANCED",
            TransactionMode: "D",
            Amount: "5005.00",
            Unit: "",
            AllUnitRedeemFlag: "",
            FolioNumber: "",
            ClientRefNo: "1",
            GatewayOrderNumber: "",
            EUINDecl: "Y",
            EUINNo: "E123456",
            Remarks: "Test"
        };
        const objResp = await placeUsermutualFundOrder(data);
        return Promise.resolve(objResp);
    } catch (error) {
        console.log(error);
        return Promise.reject(error.message);
    }
};

const _createMutualFundSIPOrder = async () => {
    try {
        // TODO: This static payload to be removed during API binding
        const data = {
            ExchangeCode: 3,
            AMCCode: "UTI",
            SchemeType: "DEBT",
            SchemeCode: "6343",
            TransactionMode: "D",
            FolioNumber: "",
            ClientRefNo: 14052152,
            MandateType: "I",
            MandateID: "561858",
            Frequency: "M",
            SIPStartDate: 1,
            NOOfInstallment: 6,
            Amount: 1500,
            FirstOrderToday: "Y",
            EUINDecl: "N",
            EUINNo: "",
            Remarks: "Testing Place SIP order"
        };
        const objResp = await placeUsermutualFundSIPOrder(data);
        return Promise.resolve(objResp);
    } catch (error) {
        console.log(error);
        return Promise.reject(error.message);
    }
};

const _createMutualFundSTPOrder = async () => {
    try {
        // TODO: This static payload to be removed during API binding
        const data = {
            ExchangeCode: 3,
            AMCCode: "FTI",
            SchemeCode: 539,
            ToSchemeCode: 537,
            TransactionMode: "P",
            FolioNumber: "123456",
            ClientRefNo: 10,
            Frequency: "M",
            STPStartDate: 1,
            NoOfTransfers: 12,
            Amount: 10000,
            FirstOrderToday: "Y",
            EUINDecl: "N",
            EUINNo: "",
            Remarks: "Test"
        };
        const objResp = await placeUsermutualFundSIPOrder(data);
        return Promise.resolve(objResp);
    } catch (error) {
        console.log(error);
        return Promise.reject(error.message);
    }
};

const _createMutualFundSWPOrder = async () => {
    try {
        // TODO: This static payload to be removed during API binding
        const data = {
            ExchangeCode: 3,
            AMCCode: "MOF",
            SchemeCode: 5143,
            TransactionMode: "D",
            FolioNumber: "",
            ClientRefNo: 3,
            Frequency: "M",
            SWPStartDate: 1,
            NOOfInstallment: 12,
            Amount: 500,
            Unit: 10,
            FirstOrderToday: "Y",
            EUINDecl: "N",
            EUINNo: "",
            Remarks: "Testing Place SWP order"
        };
        const objResp = await placeUsermutualFundSWPOrder(data);
        return Promise.resolve(objResp);
    } catch (error) {
        console.log(error);
        return Promise.reject(error.message);
    }
};

const _createMutualFundSwitchOrder = async () => {
    try {
        // TODO: This static payload to be removed during API binding
        const data = {
            ExchangeCode: 3,
            AMCCode: "MOF",
            SchemeCode: 5646,
            ToSchemeCode: 20591,
            TransactionMode: "D",
            Amount: "",
            Unit: "10",
            AllUnitRedeemFlag: "N",
            FolioNumber: "",
            ClientRefNo: "38",
            EUINDecl: "N",
            EUINNo: "",
            Remarks: "Test"
        };
        const objResp = await placeUsermutualFundSwitchOrder(data);
        return Promise.resolve(objResp);
    } catch (error) {
        console.log(error);
        return Promise.reject(error.message);
    }
};

const _cancelMutualFundOrder = async () => {
    try {
        // TODO: This static payload to be removed during API binding
        const data = {
            ClientRefNo: 123456,
            RegistrationNo: 1252105,
            GatewayOrderNumber: "051201009"
        };

        const objResp = await cancelMutualFundOrderAPI(data);
        return Promise.resolve(objResp);
    } catch (error) {
        console.log(error);
        return Promise.reject(error.message);
    }
};

const _getMutualFundSummary = async () => {
    try {
        // TODO: This static payload to be removed during API binding
        const data = {
            OBType: "C",
            productCode: 11,
            exchangeCode: 0,
            amcCode: 0,
            transactionType: "A",
            orderStatus: 0,
            subOrderStatus: -1,
            pageNo: 1,
            noOfRecordPerPage: 20,
            fromDate: "23-12-2022",
            toDate: "22-3-2023"
        };
        const objResp = await getUserAllmutualFundOrders(data);
        return Promise.resolve(objResp);
    } catch (error) {
        console.log(error);
        return Promise.reject(error.message);
    }
};

const _getMutualFundHoldings = async () => {
    try {
        // TODO: This static payload to be removed during API binding
        const data = {
            OBType: "C",
            productCode: 11,
            exchangeCode: 0,
            amcCode: 0,
            transactionType: "A",
            orderStatus: 0,
            subOrderStatus: -1,
            pageNo: 1,
            noOfRecordPerPage: 20,
            fromDate: "23-12-2022",
            toDate: "22-3-2023"
        };
        const objResp = await getMutualFundsHoldingAPI(data);
        return Promise.resolve(objResp);
    } catch (error) {
        console.log(error);
        return Promise.reject(error.message);
    }
};

const _getMutualFundMandateReport = async () => {
    try {
        // TODO: This static payload to be removed during API binding
        const data = {
            OBType: "C",
            productCode: 11,
            exchangeCode: 0,
            amcCode: 0,
            transactionType: "A",
            orderStatus: 0,
            subOrderStatus: -1,
            pageNo: 1,
            noOfRecordPerPage: 20,
            fromDate: "23-12-2022",
            toDate: "22-3-2023"
        };
        const objResp = await getMutualFundsHoldingAPI(data);
        return Promise.resolve(objResp);
    } catch (error) {
        console.log(error);
        return Promise.reject(error.message);
    }
};

const _registerMutualFundMandateReport = async () => {
    try {
        // TODO: This static payload to be removed during API binding
        const data = {
            OBType: "C",
            productCode: 11,
            exchangeCode: 0,
            amcCode: 0,
            transactionType: "A",
            orderStatus: 0,
            subOrderStatus: -1,
            pageNo: 1,
            noOfRecordPerPage: 20,
            fromDate: "23-12-2022",
            toDate: "22-3-2023"
        };
        const objResp = await getMutualFundsHoldingAPI(data);
        return Promise.resolve(objResp);
    } catch (error) {
        console.log(error);
        return Promise.reject(error.message);
    }
};

const _getMutualFundNFOWatchlist = async () => {
    try {
        const objResp = await getNfoWatchList();
        return Promise.resolve(objResp);
    } catch (error) {
        console.log(error);
        return Promise.reject(error.message);
    }
};

export {
    _getMutualFundOrder, _getMutualFundSIPOrder, _createMutualFundOrder, _createMutualFundSIPOrder, _createMutualFundSTPOrder, _createMutualFundSWPOrder, _createMutualFundSwitchOrder, _cancelMutualFundOrder,
    _getMutualFundSummary, _getMutualFundHoldings, _getMutualFundMandateReport, _registerMutualFundMandateReport, _getMutualFundNFOWatchlist
};

// Vinit R : 27-09-2023 :  Breeze - Mutual Funds - Start
